import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';

import translationEng from '@app/locales/en/translation.json';
import apiDescriptionsEng from '@app/locales/en/ApiDescriptions.json';
import translationPl from '@app/locales/pl/translation.json';
import apiDescriptionsPl from '@app/locales/pl/ApiDescriptions.json';
import { TranslationNamespace } from '@app/models';

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: 'en',
    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: '~', // changed from `:`, colons were rendered as false, if necessary change it

    interpolation: {
      escapeValue: false // react already safes from xss
    },

    resources: {
      en: {
        translations: translationEng,
        apiDesc: apiDescriptionsEng
      },
      pl: {
        translations: translationPl,
        apiDesc: apiDescriptionsPl
      }
    },
    // have a common namespace used around the full app
    ns: [TranslationNamespace.default, TranslationNamespace.apiDescription],
    defaultNS: TranslationNamespace.default
  });

export default i18n;
